module.exports = __webpack_public_path__ + "img/tech-code-icon.6568816b.svg";